import React, {PropTypes} from 'react';
import _ from 'lodash';

// components
import ToggleButton from '../../../../../common/components/c_ToggleButton';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';
import TextField from '../../../../../common/components/c_TextField';
import prettyMoney from '../../../../../lib/prettyMoney';

// menuItems for boolean toggle
const booleanDropDown = [{value: true, primaryText: 'Yes'}, {value: false, primaryText: 'No'}];

const medicareBoolean = [
  {
    value: true,
    primaryText: 'Yes',
    subElement: 'onMedicare'
  }, {
    value: false,
    primaryText: 'No',
    subElement: 'notOnMedicare'
  }
];

const healthCareBoolean = [
  {
    value: true,
    primaryText: 'Yes',
    subElement: 'hasHealthCarePlan'
  }, {
    value: false,
    primaryText: 'No',
    subElement: 'doesNotHaveHealthCarePlan'
  }
];

const socialSecurityBoolean = [
  {
    value: true,
    primaryText: 'Yes',
    subElement: 'onSocialSecurity'
  }, {
    value: false,
    primaryText: 'No',
    subElement: null
  }
];

export default function MedicareSocialSecurity(props) {
  // booleans
  const script = props.script;

  function handleDropDownMenuUI(prop, staticDataProp, label) {
    return {
      defaultValue: props.applicant.profile[prop] || false,
      menuItems: props.staticData[staticDataProp],
      floatingLabelText: label,
      onChange: props.updateTempState.bind(this, props.model, prop)
    };
  }

  function formatMoney(event) {
    event.target.value = prettyMoney(event.target.value).substring(0, 10);
  }

  function saveMoney(parent, prop, event, val) {
    // Remove non-numeric chars.
    val = val.replace(/[^0-9\.]/g, '') || 0;
    props.updateTempState(parent, prop, event, val);
  }

  return (
    <div className='expanded-accordion-content explanation-of-wahve'
      key={`medicare-social-security ${props.applicant.profile.id}`}>
      {
        script
        &&
        <div className='script speaking-callout'>
          I have just a few more questions. We ask these questions because some are concerned about the earning limitation if they are on social security and we are concerned about health care.
        </div>
      }
      <div className='on-medicare'>
        <ToggleButton
          defaultValue={props.applicant.profile.onMedicare}
          menuItems={medicareBoolean}
          onChange={props.updateTempState.bind(this, props.model, 'onMedicare')}
          floatingLabelText={'Are you on Medicare?'}
        >
          {{
            notOnMedicare: (
              <div>
                <ToggleButton
                  className='health-care-plan'
                  defaultValue={props.applicant.profile.hasHealthCarePlan}
                  menuItems={healthCareBoolean}
                  onChange={props.updateTempState.bind(this, props.model, 'hasHealthCarePlan')}
                  floatingLabelText={'Do you have a health care plan?'}
                >
                  {{
                    hasHealthCarePlan: (
                      <div>
                        <DropDownMenu
                          className='health-care-plan-type'
                          {...handleDropDownMenuUI('healthCarePlanType', 'healthCarePlanTypes', 'What type of health care plan do you have?')}
                        >
                          {{
                            Other: (
                              <TextField
                                className='health-plan-other'
                                defaultValue={props.applicant.profile.healthCarePlanOther}
                                floatingLabelText='If other, name the health plan:'
                                onBlur={props.updateTempState.bind(this, props.model, 'healthCarePlanOther')}
                              />
                            )
                          }}
                        </DropDownMenu>
                      </div>
                    )
                  }}
                </ToggleButton>
              </div>
            )
          }}
        </ToggleButton>
      </div>
      <div className='on-early-social-security'>
        <ToggleButton
          defaultValue={props.applicant.profile.onEarlySocialSecurity}
          menuItems={socialSecurityBoolean}
          onChange={props.updateTempState.bind(this, props.model, 'onEarlySocialSecurity')}
          floatingLabelText={'Are you on early Social Security?'}
        >
          {{
            onSocialSecurity: (
              <TextField
                className='social-security-earning-limit'
                defaultValue={prettyMoney(props.applicant.profile.socialSecurityEarningLimit)}
                floatingLabelText='What is your Social Security earnings limit?'
                onChange={formatMoney.bind(this)}
                onBlur={saveMoney.bind(this, props.model, 'socialSecurityEarningLimit')}
              />
            )
          }}
        </ToggleButton>
      </div>
    </div>
  );
}

MedicareSocialSecurity.propTypes = {
  staticData: PropTypes.object,
  applicant: PropTypes.object,
  script: PropTypes.bool,
  tempState: PropTypes.object,
  model: PropTypes.string.isRequired,
  updateTempState: PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_MedicareSocialSecurity/index.js